/* Touché · Regalos y 2x1 del Cyber Monday (config en snippets/touche-regalos.liquid)
   v2 · 3/11 · "a prueba de olvidos" (antes, 4 de 10 pedidos se quedaban sin su promo):
   - REGALO: se suma SOLO al carrito apenas corresponde (la primera opción con stock), con la
     propiedad _regalo_cyber; Shopify lo deja en $0 con los descuentos "Cyber · Regalo …".
     Arriba del carrito (lateral y página) se ve "🎁 Regalo incluido" y, si hay más de una
     opción, se cambia con un toque. Si la clienta lo saca a mano, no se vuelve a sumar solo:
     queda "Elegí tu regalo" arriba del carrito y se le pregunta otra vez al pagar.
     Si deja de corresponder (por ejemplo, elige transferencia en el regalo por monto), se saca solo.
     Un regalo agregado a mano desde su ficha (sin la propiedad) cuenta como el regalo de su grupo.
   - 2x1 EN LENTES: con un número impar de lentes, arriba del carrito aparece "Elegí tu segundo
     lente" con los lentes del 2x1 con stock (colección CFG.x2, sin los "A pedido") y cuánto suma
     cada uno: "Gratis" o la diferencia (Shopify regala el de menor precio).
   - AL PAGAR: al tocar cualquier "Finalizar compra" (carrito lateral, página de carrito o la
     confirmación "¡Excelente elección!"), si falta el lente gratis o un regalo que corresponde,
     se abre un aviso para elegirlo ahí mismo o seguir sin él. Corre antes que "Elegí cómo querés
     pagar" (assets/touche-metodos-pago.js), que después hace su control de siempre.
     Si algo falla o tarda más de 6 segundos, deja pasar: nunca frena una venta.
   - 2x1 O REGALO (decisión de Lean del 3/11: no se suman y elige la clienta). Con 2 lentes o más
     gana el 2x1: el regalo de marca o de Chanel no corresponde, se saca solo y arriba del carrito se
     ofrece "Prefiero el regalo" (con 2 lentes saca el lente más barato, que era el gratis, y suma el
     regalo). Con 1 lente queda el regalo y el 2x1 se ofrece como "¿Preferís el 2x1?" (si suma otro
     lente, el regalo se va). En Shopify el descuento "Cyber · 2x1 en lentes" no se combina con otros
     descuentos de producto, así que nunca se aplican las dos.
   - FUERA DEL CARRITO (ficha, colecciones; el carrito de esta web es página, no lateral): si se
     sumó un regalo solo, o si se agregó un lente y queda impar, aparece un aviso abajo con
     "Ir al carrito" durante 9 segundos.
   - Ficha: debajo de "Beneficios Touché", qué regalo o promo tiene el producto y cuánto falta.
   Reglas (sin cambios): "sin promo" = sin la etiqueta promo-activa. Regalo de marca desde
   CFG.minMarca en productos de esa marca (sin lentes ni bolsas de regalo ni regalos). Regalo por
   productos (grupo con "hs", Chanel 25 y Flap). Regalo por monto: solo a precio de lista (tarjeta o
   Mercado Pago) y sin ningún producto con promo. Los regalos no dan regalo. */
(function () {
  'use strict';
  if (window.__toucheRegalos) return;
  window.__toucheRegalos = true;
  var cfgEl = document.getElementById('touche-regalos-cfg');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PROP = '_regalo_cyber';
  var PROMO_TAG = 'promo-activa';
  var AUTO = CFG.auto !== false;
  var gifts = {}, brands = {}, byVendor = {}, giftVar = {}, montoVar = {};
  var noMarca = CFG.noMarca || [];
  var minMarca = CFG.minMarca || 0;
  (CFG.gifts || []).forEach(function (h) { gifts[h] = true; });
  (CFG.brands || []).forEach(function (v) { brands[v] = true; });
  (CFG.groups || []).forEach(function (g) {
    if (g.v) byVendor[g.v] = g;
    (g.o || []).forEach(function (o) {
      (giftVar[o.id] = giftVar[o.id] || []).push(g.k);
      if (g.k === 'monto') montoVar[o.id] = true;
    });
  });

  function money(c) {
    c = Math.max(0, Math.round(c || 0));
    var ent = Math.floor(c / 100), dec = c % 100;
    return '$' + String(ent).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (dec ? ',' + (dec < 10 ? '0' : '') + dec : '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
  function pctW(v) { return Math.max(4, Math.min(100, Math.round(v * 100))) + '%'; }
  function imgW(src, w) { if (!src) return ''; src = String(src); return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  /* Estado de esta visita: auto_k = el regalo lo pusimos nosotros; no_k = la clienta lo sacó (1) o dijo que no al pagar (2) */
  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem('trg2_' + k);
      if (v === null) sessionStorage.removeItem('trg2_' + k);
      else sessionStorage.setItem('trg2_' + k, String(v));
    } catch (e) {}
    return null;
  }

  /* ---------- etiqueta promo-activa (misma fuente que "Elegí cómo querés pagar") ---------- */
  var tagCache = {};
  function seedTags() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-touche-mp]'), function (b) {
      String(b.getAttribute('data-tags') || '').split(',').forEach(function (p) {
        var i = p.lastIndexOf(':');
        if (i > 0) tagCache[p.slice(0, i)] = p.slice(i + 1) === '1';
      });
    });
    if (CFG.product && CFG.product.h) tagCache[CFG.product.h] = !!CFG.product.promo;
  }
  function isPromo(handle) {
    if (!handle) return Promise.resolve(true);
    if (tagCache.hasOwnProperty(handle)) return Promise.resolve(tagCache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('p'); return r.json(); })
      .then(function (p) {
        var on = ((p && p.tags) || []).some(function (t) { return String(t).toLowerCase() === PROMO_TAG; });
        tagCache[handle] = on;
        return on;
      })
      .catch(function () { return true; }); /* si no se puede saber, no suma */
  }

  function giftKey(it) { return it.properties && it.properties[PROP] ? String(it.properties[PROP]) : ''; }
  function mpBlock() { return document.querySelector('[data-touche-mp]'); }
  var lastCart = null, lastA = null;
  function metodo() {
    var b = mpBlock(), m = b && b.getAttribute('data-metodo');
    if (m) return m;
    try { m = localStorage.getItem('touche_metodo_pago_v1'); } catch (e) { m = null; }
    if (m) return m;
    var at = lastCart && lastCart.attributes && lastCart.attributes._scaladiscount;
    return at === '1' || at === '2' ? 'transferencia' : 'tarjeta';
  }
  function lista() { return metodo() !== 'transferencia'; }
  function unitPrice(it) { return it.original_price != null ? it.original_price : (it.price || 0); }
  function firstOk(g) { var o = (g.o || []).filter(function (x) { return x.ok; }); return o[0] || null; }
  /* la opción que eligió antes en esta visita (si sigue con stock) o la primera con stock */
  function pickOk(g) {
    var id = ss('pick_' + g.k);
    var o = id && (g.o || []).filter(function (x) { return x.ok && String(x.id) === String(id); })[0];
    return o || firstOk(g);
  }

  function analyze(cart) {
    lastCart = cart;
    var items = (cart && cart.items) || [];
    seedTags();
    return Promise.all(items.map(function (it) { return giftKey(it) || giftVar[it.variant_id] ? Promise.resolve(true) : isPromo(it.handle); })).then(function (promos) {
      var a = { sin: 0, blocker: false, trig: {}, brand: {}, lines: {}, extra: [], loose: [], lista: lista(), eligible: {}, count: 0, handles: {}, lentes: [], lentesN: 0 };
      items.forEach(function (it, i) {
        var k = giftKey(it);
        if (k) { if (a.lines[k]) a.extra.push(it); else a.lines[k] = it; return; }
        if (giftVar[it.variant_id]) { a.loose.push(it); return; } /* regalo agregado desde su ficha */
        a.count += it.quantity;
        a.handles[it.handle] = true;
        if (it.product_type === CFG.lentes && !gifts[it.handle]) {
          for (var q = 0; q < it.quantity; q++) a.lentes.push(unitPrice(it));
        }
        if (brands[it.vendor] && !gifts[it.handle] && it.product_type !== CFG.lentes && noMarca.indexOf(it.product_type) < 0) {
          a.brand[it.vendor] = (a.brand[it.vendor] || 0) + (it.original_line_price || 0); /* lentes en 2x1 y bolsas de regalo: no suman */
        }
        (CFG.groups || []).forEach(function (g) { if (g.hs && g.hs.indexOf(it.handle) >= 0) a.trig['k:' + g.k] = true; });
        if (promos[i]) a.blocker = true; /* cualquier producto con su propia promo (regalo o 2x1) */
        if (!promos[i]) a.sin += it.original_line_price || 0;
      });
      a.lentesN = a.lentes.length;
      Object.keys(a.brand).forEach(function (v) { if (a.brand[v] >= minMarca) a.trig[v] = true; });
      (CFG.groups || []).forEach(function (g) {
        a.eligible[g.k] = g.k === 'monto' ? (!a.blocker && a.lista && a.sin >= CFG.min) : (g.hs ? !!a.trig['k:' + g.k] : !!a.trig[g.v]);
      });
      /* un solo regalo igual por pedido: si ya corresponde el del grupo "uno", este no se ofrece */
      (CFG.groups || []).forEach(function (g) { if (g.uno && a.eligible[g.k] && a.eligible[g.uno]) a.eligible[g.k] = false; });
      /* 2x1 o regalo: no se suman. Con 2 lentes o más gana el 2x1; con 1 lente queda el regalo */
      a.conflicto = [];
      (CFG.groups || []).forEach(function (g) {
        if (g.k === 'monto' || !a.eligible[g.k] || !a.lentesN) return;
        a.conflicto.push(g);
        if (a.lentesN >= 2) a.eligible[g.k] = false;
      });
      a.regaloSinLente = a.lentesN === 1 && a.conflicto.length > 0;
      a.x2gana = a.lentesN >= 2 && a.conflicto.length > 0;
      /* regalo agregado a mano desde su ficha: cuenta como el regalo de su grupo */
      a.loose.forEach(function (it) {
        var used = (giftVar[it.variant_id] || []).some(function (k) {
          if (a.eligible[k] && !a.lines[k]) { it.__loose = true; a.lines[k] = it; return true; }
          return false;
        });
        /* regalo por monto agregado a mano que Shopify deja en $0 cuando no corresponde (transferencia): se saca */
        if (!used && montoVar[it.variant_id] && !it.final_line_price && !a.eligible.monto) a.extra.push(it);
      });
      return a;
    });
  }

  /* ---------- carrito ---------- */
  function themeTargets() {
    var t = { drawer: null, page: null, sections: [] };
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function' && document.getElementById('cart-drawer')) { t.drawer = cd; t.sections.push('cart-drawer'); }
    var ci = document.querySelector('cart-items');
    if (ci && typeof ci.getSectionsToRender === 'function' && typeof ci.renderContents === 'function') {
      try { ci.getSectionsToRender().forEach(function (s) { if (s.section && t.sections.indexOf(s.section) < 0) t.sections.push(s.section); }); t.page = ci; } catch (e) {}
    }
    return t;
  }
  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  /* Vuelve a dibujar el carrito lateral o la página de carrito después de un cambio */
  function rerender() {
    var t = themeTargets();
    if (!t.sections.length) {
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
      /* ficha o colección: solo el número del carrito */
      return getCart().then(function (c) {
        try { if (window.FoxThemeCartHelpers) FoxThemeCartHelpers.updateCartCount(c.item_count); } catch (e) {}
        return c;
      });
    }
    return post('cart/update.js', { sections: t.sections.slice(0, 5).join(','), sections_url: location.pathname }).then(function (c) {
      try { if (t.drawer) t.drawer.renderContents(c, true, false); } catch (e) {}
      try { if (t.page) t.page.renderContents(c); } catch (e) {}
      try { if (window.FoxThemeEvents && window.PUB_SUB_EVENTS) window.FoxThemeEvents.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'touche-regalos', cartData: c }); } catch (e) {}
      try { if (window.ToucheMP) window.ToucheMP.refresh(); } catch (e) {}
      try { if (window.FoxThemeCartHelpers && typeof c.item_count === 'number') FoxThemeCartHelpers.updateCartCount(c.item_count); } catch (e) {}
      return c;
    });
  }

  var busy = false;
  function setBusy(on) {
    busy = on;
    Array.prototype.forEach.call(document.querySelectorAll('[data-touche-regalos], [data-trg-top], .trg-modal__box'), function (b) { b.classList.toggle('is-busy', on); });
  }

  /* Regalos que sobran: ya no corresponden, más de 1 unidad o repetidos */
  function fixes(a) {
    var ops = {}, n = 0;
    Object.keys(a.lines).forEach(function (k) {
      var it = a.lines[k];
      if (it.__loose) return; /* lo agregó ella desde la ficha: no se toca */
      if (!a.eligible[k] || !a.count) { ops[it.key] = 0; n++; ss('auto_' + k, null); }
      else if (it.quantity > 1) { ops[it.key] = 1; n++; }
    });
    a.extra.forEach(function (it) { ops[it.key] = 0; n++; });
    return n ? ops : null;
  }
  /* Regalo que corresponde y falta: se suma solo (uno por vez), salvo que la clienta lo haya sacado */
  function nextAdd(a) {
    if (!AUTO || !a.count) return null;
    var out = null;
    (CFG.groups || []).some(function (g) {
      if (!a.eligible[g.k] || a.lines[g.k]) return false;
      if (ss('auto_' + g.k)) { ss('auto_' + g.k, null); if (!ss('no_' + g.k)) ss('no_' + g.k, '1'); return false; } /* lo sacó ella */
      if (ss('no_' + g.k) || ss('fail_' + g.k)) return false;
      var o = pickOk(g);
      if (!o) return false;
      out = { k: g.k, id: o.id, t: o.t };
      return true;
    });
    return out;
  }
  function addGift(k, id) {
    var props = {};
    props[PROP] = k;
    return post('cart/add.js', { items: [{ id: Number(id), quantity: 1, properties: props }] }).then(function (r) {
      ss('auto_' + k, '1');
      ss('no_' + k, null);
      ss('pick_' + k, id);
      return r;
    });
  }

  /* ---------- 2x1: lentes para elegir ---------- */
  var X2 = null, x2Loading = false;
  function load2x1() {
    if (X2 || x2Loading || !CFG.x2) return;
    x2Loading = true;
    fetch(ROOT + 'collections/' + encodeURIComponent(CFG.x2) + '/products.json?limit=250', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('x2'); return r.json(); })
      .then(function (d) {
        X2 = ((d && d.products) || []).map(function (p) {
          if (!p || gifts[p.handle]) return null;
          var aPedido = (p.tags || []).some(function (t) { return /a[\s-]?pedido/i.test(String(t)); });
          if (aPedido) return null; /* los "A pedido" necesitan aceptar condiciones en su ficha */
          var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0];
          if (!v) return null;
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          return { id: v.id, t: p.title, h: p.handle, p: Math.round(parseFloat(v.price) * 100) || 0, img: imgW(img, 200) };
        }).filter(Boolean);
      })
      .catch(function () { X2 = []; })
      .then(function () { x2Loading = false; schedule(); });
  }
  function paidSum(arr) {
    var s = arr.slice().sort(function (x, y) { return y - x; }), n = Math.ceil(s.length / 2), t = 0;
    for (var i = 0; i < n; i++) t += s[i];
    return t;
  }
  function extra(a, p) { return paidSum(a.lentes.concat([p])) - paidSum(a.lentes); }
  function cardsHTML(a) {
    if (!X2) return '<p class="trg__s trg-load">Cargando lentes…</p>';
    if (!X2.length) return '<p class="trg__s"><a href="' + ROOT + 'collections/' + esc(CFG.x2) + '">Ver los lentes del 2x1</a></p>';
    var list = X2.map(function (o, i) { return { o: o, e: extra(a, o.p), i: i }; })
      .sort(function (x, y) { return x.e - y.e || x.i - y.i; });
    return '<div class="trg-rail" data-trg-rail>' + list.map(function (x) {
      return '<button type="button" class="trg-card" data-trg-lente="' + x.o.id + '" aria-label="Agregar ' + esc(x.o.t) + (x.e ? ', suma ' + money(x.e) : ', gratis') + '">' +
        (x.o.img ? '<img src="' + esc(x.o.img) + '" alt="" width="88" height="88" loading="lazy">' : '') +
        '<span class="trg-card__n">' + esc(x.o.t) + '</span>' +
        '<small class="trg-card__p' + (x.e ? '' : ' is-free') + '">' + (x.e ? '+ ' + money(x.e) : 'Gratis') + '</small>' +
        '<span class="trg-card__cta" aria-hidden="true">Agregar</span></button>';
    }).join('') + '</div>';
  }
  function lentesTxt(n) { return n === 1 ? '1 lente' : n + ' lentes'; }
  function pick2x1HTML(a) {
    return '<div class="trg-pend trg-2x1">' +
      '<div class="trg-2x1__head"><div><p class="trg__t">Elegí tu segundo lente: <span class="trg-free">es gratis</span></p>' +
      '<p class="trg__s">Tenés ' + lentesTxt(a.lentesN) + ' del 2x1. Sumá uno más con un toque y el de menor precio te sale gratis.</p></div>' +
      '<div class="trg-nav" aria-hidden="true"><button type="button" tabindex="-1" data-trg-nav="-1">‹</button><button type="button" tabindex="-1" data-trg-nav="1">›</button></div></div>' +
      cardsHTML(a) + '</div>';
  }

  function navHTML() {
    return '<div class="trg-nav" aria-hidden="true"><button type="button" tabindex="-1" data-trg-nav="-1">‹</button><button type="button" tabindex="-1" data-trg-nav="1">›</button></div>';
  }
  /* 1 lente + regalo: el 2x1 se ofrece en lugar del regalo */
  function alt2x1HTML(a) {
    return '<div class="trg-alt trg-2x1">' +
      '<div class="trg-2x1__head"><div><p class="trg__t">¿Preferís el 2x1?</p>' +
      '<p class="trg__s">Sumá otro lente y te sale gratis, pero reemplaza a tu regalo: no se suman.</p></div>' + navHTML() + '</div>' +
      cardsHTML(a) + '</div>';
  }
  /* 2 lentes + producto con regalo: gana el 2x1 y se ofrece cambiarlo por el regalo */
  function swapHTML(a) {
    var g = a.conflicto[0];
    var h = '<div class="trg-swap"><p class="trg__s"><strong>El 2x1 no se suma con los regalos.</strong> Tu compra también daba ' + esc(g.n) + ' de regalo.';
    if (a.lentesN === 2) {
      h += ' Si lo preferís, cambiá el lente gratis por el regalo.</p><button type="button" class="trg-swapbtn" data-trg-regalo>Prefiero el regalo</button>';
    } else {
      h += '</p>';
    }
    return h + '</div>';
  }

  /* ---------- lo que se ve arriba del carrito ---------- */
  function optsHTML(g) {
    return (g.o || []).map(function (o) {
      return '<button type="button" class="trg__op" data-trg-add="' + o.id + '" data-trg-k="' + g.k + '"' + (o.ok ? '' : ' disabled') + '>' +
        (o.img ? '<img src="' + esc(o.img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<span>' + esc(o.t) + '</span><small>' + (o.ok ? 'Gratis' : 'Sin stock') + '</small></button>';
    }).join('');
  }
  function topHTML(a) {
    if (!a.count) return '';
    var h = '';
    (CFG.groups || []).forEach(function (g) {
      if (!a.eligible[g.k]) return;
      var line = a.lines[g.k], opts = g.o || [];
      if (line) {
        var others = opts.filter(function (o) { return o.ok && String(o.id) !== String(line.variant_id); });
        h += '<div class="trg-gift">' +
          (line.image ? '<img src="' + esc(imgW(line.image, 120)) + '" alt="" width="56" height="56">' : '') +
          '<div><p class="trg-gift__k"><span aria-hidden="true">🎁</span> Regalo incluido</p>' +
          '<p class="trg-gift__n"><strong>' + esc(line.product_title) + '</strong> <span class="trg-free">Gratis</span></p>' +
          '<p class="trg-gift__w">' + esc(g.w) + '. Ya está en tu carrito: no tenés que hacer nada.</p></div></div>';
        if (others.length) {
          h += '<p class="trg-gift__alt">¿Preferís otro ' + esc(g.c || 'modelo') + '?</p><div class="trg-chips">' + others.map(function (o) {
            return '<button type="button" class="trg-chip" data-trg-swap="' + o.id + '" data-trg-k="' + g.k + '" data-trg-old="' + esc(line.key) + '" data-trg-oldq="' + line.quantity + '">' +
              (o.img ? '<img src="' + esc(o.img) + '" alt="" width="32" height="32" loading="lazy">' : '') + '<span>' + esc(o.t) + '</span></button>';
          }).join('') + '</div>';
        }
      } else if (firstOk(g)) {
        if (AUTO && !ss('no_' + g.k) && !ss('fail_' + g.k)) {
          h += '<p class="trg-gift__k trg-gift__k--wait"><span aria-hidden="true">🎁</span> Sumando tu regalo…</p>';
        } else {
          h += '<div class="trg-pend"><p class="trg__t">Elegí tu regalo: <span class="trg-free">es gratis</span></p><p class="trg__s">' + esc(g.msg) + '</p><div class="trg__grid">' + optsHTML(g) + '</div></div>';
        }
      }
    });
    if (a.lentesN) {
      if (a.lentesN % 2) h += a.regaloSinLente ? alt2x1HTML(a) : pick2x1HTML(a);
      else h += '<p class="trg__row trg__row--ok"><span aria-hidden="true">🕶️</span> <strong>2x1 aplicado:</strong> llevás ' + a.lentesN + ' lentes y pagás ' + (a.lentesN / 2) + '. Van sin packaging.</p>';
      if (a.x2gana) h += swapHTML(a);
    }
    return h;
  }

  /* ---------- lo que se ve debajo de "Elegí cómo querés pagar" ---------- */
  function row(html, ratio, ok) {
    return '<p class="trg__row' + (ok ? ' trg__row--ok' : '') + '">' + html + '</p>' + (ratio != null ? '<div class="trg__bar" aria-hidden="true"><i style="width:' + pctW(ratio) + '"></i></div>' : '');
  }
  function bottomHTML(a) {
    if (!a.count) return '';
    var h = '';
    (CFG.groups || []).forEach(function (g) {
      if (g.k === 'monto' || g.hs || a.eligible[g.k] || !a.brand[g.v]) return;
      h += row('Te faltan <strong>' + money(minMarca - a.brand[g.v]) + '</strong> en ' + esc(g.m) + ' para llevarte ' + esc(g.n) + ' de regalo.', a.brand[g.v] / minMarca);
    });
    var min = CFG.min;
    if (!a.blocker && a.lista && a.sin > 0 && a.sin < min) {
      h += row('Te faltan <strong>' + money(min - a.sin) + '</strong> en productos sin promo para tu regalo (' + esc(CFG.montoNombre) + ') pagando con tarjeta o Mercado Pago.', a.sin / min);
    } else if (!a.blocker && !a.lista && a.sin >= min) {
      h += '<p class="trg__note">Con transferencia tenés el descuento. El regalo (' + esc(CFG.montoNombre) + ') es solo pagando a precio de lista, con tarjeta o Mercado Pago.</p>';
    } else if (a.blocker && a.lista && a.sin >= min) {
      h += '<p class="trg__note">El regalo por monto no se suma: tu pedido ya tiene un producto con su propia promo (regalo o 2x1).</p>';
    }
    return h;
  }

  function mount() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-touche-mp]'), function (mp) {
      var next = mp.nextElementSibling;
      if (next && next.hasAttribute('data-touche-regalos')) return;
      var d = document.createElement('div');
      d.className = 'trg';
      d.setAttribute('data-touche-regalos', '');
      d.setAttribute('aria-live', 'polite');
      d.hidden = true;
      mp.parentNode.insertBefore(d, mp.nextSibling);
    });
    /* arriba de los productos: carrito lateral y página de carrito */
    var spots = [];
    var cdi = document.querySelector('#cart-drawer cart-drawer-items');
    if (cdi) spots.push([cdi, true]);
    var tw = document.querySelector('cart-items .f-cart__title-wrapper');
    if (tw) spots.push([tw, false]);
    spots.forEach(function (s) {
      var ref = s[0], before = s[1];
      var sib = before ? ref.previousElementSibling : ref.nextElementSibling;
      if (sib && sib.hasAttribute('data-trg-top')) return;
      var d = document.createElement('div');
      d.className = 'trg trg-top' + (before ? ' trg-top--drawer' : ' trg-top--page');
      d.setAttribute('data-trg-top', '');
      d.setAttribute('aria-live', 'polite');
      d.hidden = true;
      ref.parentNode.insertBefore(d, before ? ref : ref.nextSibling);
    });
  }
  /* En las opciones Tarjeta y Mercado Pago: "+ Regalo" cuando el pedido lo gana a precio de lista */
  function paintHints(a) {
    var on = !!a.count && !a.blocker && a.sin >= CFG.min;
    Array.prototype.forEach.call(document.querySelectorAll('[data-touche-mp] .tmp__opt'), function (opt) {
      var m = opt.getAttribute('data-metodo');
      if (m !== 'tarjeta' && m !== 'mercadopago') return;
      var body = opt.querySelector('.tmp__body');
      if (!body) return;
      var el = body.querySelector('.trg-mpgift');
      if (!on) { if (el) el.parentNode.removeChild(el); return; }
      if (!el) {
        el = document.createElement('span');
        el.className = 'trg-mpgift';
        el.textContent = '🎁 + Regalo: ' + CFG.montoNombre;
        body.appendChild(el);
      }
    });
  }
  function paintBox(sel, html) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (b) {
      if (b.__html !== html) { b.__html = html; b.innerHTML = html; }
      if (b.hidden !== !html) b.hidden = !html;
      var pend = html.indexOf('trg-pend') >= 0;
      if (b.classList.contains('trg-top--pend') !== pend) b.classList.toggle('trg-top--pend', pend);
    });
  }
  function paintCart(a) {
    paintHints(a);
    paintBox('[data-trg-top]', topHTML(a));
    paintBox('[data-touche-regalos]', bottomHTML(a));
  }

  /* ---------- ficha ---------- */
  function fichaHTML(a) {
    var P = CFG.product;
    if (!P) return '';
    var min = CFG.min, min25 = CFG.min25, pct = CFG.pct;
    if (P.gift) return '<p class="trg__t">Regalo del Cyber Monday</p><p class="trg__s">Este producto es uno de los regalos de la promo. También lo podés comprar.</p>';
    var g = byVendor[P.v], lentes = P.ty === CFG.lentes, h = '';
    if (lentes) return '<p class="trg__t">2x1 en lentes</p><p class="trg__s">Llevá 2 lentes y uno te sale gratis. Podés combinar los modelos que quieras. Los lentes en 2x1 no suman otro regalo.</p>';
    if (g) {
      /* el recuadro de la promo ya lo explica; acá solo cuánto falta para el mínimo de la marca */
      if (noMarca.indexOf(P.ty) >= 0) return '';
      var enC = !!a.handles[P.h], sb = (a.brand[P.v] || 0) + (enC ? 0 : (P.p || 0));
      if (sb >= minMarca) return '';
      return '<p class="trg__t">Regalo ' + esc(g.m) + ' desde ' + money(minMarca) + '</p>' +
        row((a.brand[P.v] ? 'Con lo que tenés en el carrito, te faltan ' : 'Te faltan ') + '<strong>' + money(minMarca - sb) + '</strong> en ' + esc(g.m) + ' para llevarte ' + esc(g.n) + ' de regalo.', sb / minMarca);
    }
    if (P.promo) return ''; /* ya lo explica "Beneficios Touché" y el recuadro de su promo: un solo aviso */
    var enCarrito = !!a.handles[P.h];
    var s = a.sin + (enCarrito ? 0 : (P.p || 0)), pre = enCarrito ? 'Con lo que tenés en el carrito, ' : (a.sin > 0 ? 'Con lo que ya tenés en el carrito, ' : '');
    var regalo = !a.blocker;
    if (s >= min25) {
      return '<p class="trg__t">Con este producto llegás al ' + pct + '% OFF</p><p class="trg__s">' + pre + 'sumás ' + money(s) + ' en productos sin promo: ' + pct + '% OFF pagando con transferencia' + (regalo ? ', o un regalo (' + esc(CFG.montoNombre) + ') pagando a precio de lista con tarjeta o Mercado Pago.' : '.') + '</p>';
    }
    h = '<p class="trg__t">' + (s >= min && regalo ? 'Con este producto elegís regalo' : 'Te falta poco para tu beneficio') + '</p>';
    if (regalo) {
      h += s >= min ? row('Ya tenés tu regalo (' + esc(CFG.montoNombre) + ') pagando con tarjeta o Mercado Pago.', null, true) : row(pre + 'te faltan <strong>' + money(min - s) + '</strong> para tu regalo (' + esc(CFG.montoNombre) + ') pagando con tarjeta o Mercado Pago.', s / min);
    }
    h += row((regalo ? 'Y te faltan ' : pre + 'te faltan ') + '<strong>' + money(min25 - s) + '</strong> para el ' + pct + '% OFF pagando con transferencia.', s / min25);
    return h;
  }
  function paintFicha(a) {
    if (!CFG.product) return;
    var box = document.querySelector('.touche-pagos');
    if (!box) return;
    var f = box.nextElementSibling;
    if (!f || !f.hasAttribute('data-trg-ficha')) {
      f = document.createElement('div');
      f.className = 'trg trg--ficha';
      f.setAttribute('data-trg-ficha', '');
      box.parentNode.insertBefore(f, box.nextSibling);
    }
    var html = fichaHTML(a);
    if (f.__html !== html) { f.__html = html; f.innerHTML = html; }
    if (f.hidden !== !html) f.hidden = !html;
  }

  /* ---------- aviso flotante fuera del carrito (ficha, colecciones) ---------- */
  function onCart() { return !!document.querySelector('[data-trg-top]:not([hidden])') || /\/cart\/?$/.test(location.pathname); }
  var toastT = null, lensToast = false;
  function toast(html) {
    var el = document.querySelector('.trg-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'trg-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '<p>' + html + '</p><a href="' + ROOT + 'cart">Ir al carrito</a><button type="button" data-trg-toast-x aria-label="Cerrar">×</button>';
    el.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.hidden = true; }, 9000);
  }
  document.addEventListener('product-ajax:added', function () { lensToast = true; schedule(); });

  /* ---------- aviso al tocar "Finalizar compra" ---------- */
  var guard = { el: null, btn: null, drawer: false, checking: false, lastFocus: null };
  function sig2x1(a) { return a.lentes.slice().sort().join(','); }
  function issues(a) {
    var out = [];
    if (!a || !a.count) return out;
    if (a.lentesN % 2 === 1 && !a.regaloSinLente && ss('ok2x1') !== sig2x1(a)) out.push({ t: '2x1' });
    (CFG.groups || []).forEach(function (g) {
      if (!a.eligible[g.k] || a.lines[g.k] || ss('no_' + g.k) === '2' || !firstOk(g)) return;
      out.push({ t: 'gift', g: g });
    });
    return out;
  }
  function modalHTML(a, list) {
    var has2 = list.some(function (x) { return x.t === '2x1'; });
    var gs = list.filter(function (x) { return x.t === 'gift'; });
    var title = has2 && gs.length ? '¡Esperá! Te falta elegir lo que te llevás gratis' : (has2 ? '¡Esperá! Te falta tu lente gratis' : '¡Esperá! Te falta tu regalo');
    var h = '<button type="button" class="trg-modal__x" data-trg-close aria-label="Volver al carrito">×</button>' +
      '<p class="trg-modal__t" id="trg-modal-t">' + title + '</p>';
    if (has2) {
      h += '<p class="trg__s">Tenés ' + lentesTxt(a.lentesN) + ' del 2x1. Tocá el que quieras y el de menor precio te sale gratis. Si seguís sin elegir, pagás tus lentes sin el 2x1.</p>' +
        '<div class="trg-nav trg-nav--modal" aria-hidden="true"><button type="button" tabindex="-1" data-trg-nav="-1">‹</button><button type="button" tabindex="-1" data-trg-nav="1">›</button></div>' + cardsHTML(a);
    }
    gs.forEach(function (x) {
      h += '<p class="trg__t trg-modal__sub">' + esc(x.g.n.charAt(0).toUpperCase() + x.g.n.slice(1)) + ' de regalo</p><p class="trg__s">' + esc(x.g.msg) + '</p><div class="trg__grid">' + optsHTML(x.g) + '</div>';
    });
    h += '<div class="trg-modal__foot"><button type="button" class="trg-modal__skip" data-trg-skip>' +
      (has2 && gs.length ? 'Seguir sin elegir' : (has2 ? 'Seguir sin el lente gratis' : 'Seguir sin el regalo')) + '</button></div>';
    return h;
  }
  function closeModal() {
    if (!guard.el) return;
    var el = guard.el;
    guard.el = null;
    document.documentElement.classList.remove('trg-modal-open');
    if (el.parentNode) el.parentNode.removeChild(el);
    try { if (guard.lastFocus && guard.lastFocus.isConnected) guard.lastFocus.focus(); } catch (e) {}
  }
  function openModal(btn, a, list) {
    guard.btn = btn;
    guard.drawer = !!(btn && btn.closest && btn.closest('#cart-drawer'));
    guard.list = list;
    guard.lastFocus = document.activeElement;
    if (list.some(function (x) { return x.t === '2x1'; })) load2x1();
    if (!guard.el) {
      guard.el = document.createElement('div');
      guard.el.className = 'trg-modal';
      guard.el.innerHTML = '<div class="trg trg-modal__box" role="dialog" aria-modal="true" aria-labelledby="trg-modal-t"></div>';
      document.body.appendChild(guard.el);
      document.documentElement.classList.add('trg-modal-open');
    }
    paintModal(a);
    var first = guard.el.querySelector('.trg-card, .trg__op:not([disabled]), [data-trg-close]');
    try { if (first) first.focus({ preventScroll: true }); } catch (e) {}
  }
  function paintModal(a) {
    if (!guard.el) return;
    var box = guard.el.querySelector('.trg-modal__box');
    var list = issues(a);
    if (!list.length) list = guard.list || [];
    var html = modalHTML(a, list);
    if (box.__html !== html) { box.__html = html; box.innerHTML = html; }
  }
  /* Espera a que termine un regalo que se está sumando (máx. ms) antes de revisar el carrito */
  function idle(ms) {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function tick() { if ((!busy && !pending) || Date.now() - t0 > ms) res(); else setTimeout(tick, 120); })();
    });
  }
  function findCheckout() {
    var all = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    for (var i = 0; i < all.length; i++) {
      var inDrawer = !!all[i].closest('#cart-drawer');
      if (inDrawer === guard.drawer && all[i].offsetParent !== null) return all[i];
    }
    return all[0] || null;
  }
  function go(btn) {
    closeModal();
    if (!btn || !btn.isConnected) btn = findCheckout();
    if (!btn) { location.href = ROOT + 'checkout'; return; }
    btn.__trgOk = true;
    btn.click();
    setTimeout(function () { btn.__trgOk = false; }, 2500);
  }
  /* Después de elegir en el aviso: si ya no falta nada, sigue solo al pago */
  function afterPick() {
    return getCart().then(analyze).then(function (a) {
      lastA = a;
      if (!guard.el) return;
      if (!issues(a).length) go(guard.btn);
      else paintModal(a);
    }).catch(function () { go(guard.btn); });
  }
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn || btn.__trgOk || btn.__toucheGo) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (guard.checking) return;
    guard.checking = true;
    guard.drawer = !!btn.closest('#cart-drawer');
    var done = false;
    var timer = setTimeout(function () { if (done) return; done = true; guard.checking = false; go(btn); }, 6000);
    idle(2500).then(getCart).then(analyze).then(function (a) {
      if (done) return;
      done = true; clearTimeout(timer); guard.checking = false;
      lastA = a;
      var list = issues(a);
      if (!list.length) go(btn);
      else openModal(btn, a, list);
    }).catch(function () {
      if (done) return;
      done = true; clearTimeout(timer); guard.checking = false;
      go(btn);
    });
  }, true);
  document.addEventListener('keydown', function (e) { if (guard.el && (e.key === 'Escape' || e.key === 'Esc')) closeModal(); });

  /* ---------- ciclo ---------- */
  var pending = null, again = false;
  function run() {
    if (pending) { again = true; return pending; }
    mount();
    pending = getCart()
      .then(analyze)
      .then(function (a) {
        lastA = a;
        (CFG.groups || []).forEach(function (g) { if (!a.eligible[g.k]) { ss('auto_' + g.k, null); ss('no_' + g.k, null); } });
        var ops = busy ? null : fixes(a);
        if (ops) {
          setBusy(true);
          return post('cart/update.js', { updates: ops }).then(rerender).catch(function () {}).then(function () { setBusy(false); again = true; });
        }
        var add = busy ? null : nextAdd(a);
        if (add) {
          setBusy(true);
          return addGift(add.k, add.id)
            .then(function () { if (!onCart()) toast('<span aria-hidden="true">🎁</span> Sumamos tu regalo al carrito: <strong>' + esc(add.t) + '</strong>, gratis.'); })
            .catch(function () { ss('fail_' + add.k, '1'); })
            .then(rerender).catch(function () {}).then(function () { setBusy(false); again = true; });
        }
        if (a.lentesN % 2 === 1) load2x1();
        if (lensToast) {
          lensToast = false;
          if (a.x2gana && !onCart()) toast('<span aria-hidden="true">🕶️</span> <strong>2x1 aplicado.</strong> No se suma con el regalo, así que lo sacamos. Si lo preferís, lo cambiás en el carrito.');
          else if (a.lentesN % 2 === 1 && !a.regaloSinLente && !onCart()) toast('<span aria-hidden="true">🕶️</span> <strong>2x1 en lentes:</strong> sumá otro lente y uno te sale gratis. Lo elegís con un toque en el carrito.');
        }
        paintCart(a);
        paintFicha(a);
        if (guard.el) paintModal(a);
      })
      .catch(function () {})
      .then(function () { pending = null; if (again) { again = false; schedule(); } });
    return pending;
  }
  var schedule = debounce(run, 250);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var nav = t.closest('[data-trg-nav]');
    if (nav) {
      e.preventDefault();
      var wrap = nav.closest('.trg-2x1, .trg-modal__box');
      var rail = wrap && wrap.querySelector('[data-trg-rail]');
      if (rail) rail.scrollBy({ left: Number(nav.getAttribute('data-trg-nav')) * Math.max(160, rail.clientWidth * 0.8), behavior: 'smooth' });
      return;
    }
    if (t.closest('[data-trg-toast-x]')) { var tt = t.closest('.trg-toast'); if (tt) tt.hidden = true; return; }
    if (guard.el && t.closest('[data-trg-close]')) { e.preventDefault(); closeModal(); return; }
    if (guard.el && t === guard.el) { closeModal(); return; } /* toque fuera del aviso */
    if (guard.el && t.closest('[data-trg-skip]')) {
      e.preventDefault();
      var a0 = lastA;
      (guard.list || []).forEach(function (x) {
        if (x.t === '2x1' && a0) ss('ok2x1', sig2x1(a0));
        if (x.t === 'gift') ss('no_' + x.g.k, '2');
      });
      go(guard.btn);
      return;
    }
    var pref = t.closest('[data-trg-regalo]');
    if (pref) {
      e.preventDefault();
      if (busy || !lastCart) return;
      /* saca 1 unidad del lente más barato (el que salía gratis); el regalo se suma solo después */
      var lens = (lastCart.items || []).filter(function (it) { return it.product_type === CFG.lentes && !gifts[it.handle] && !giftKey(it) && !giftVar[it.variant_id]; })
        .sort(function (x, y) { return unitPrice(x) - unitPrice(y); })[0];
      if (!lens) return;
      setBusy(true);
      var u = {};
      u[lens.key] = Math.max(0, lens.quantity - 1);
      (lastA && lastA.conflicto || []).forEach(function (g) { ss('no_' + g.k, null); ss('auto_' + g.k, null); });
      post('cart/update.js', { updates: u }).then(rerender).catch(function () {}).then(function () { setBusy(false); schedule(); });
      return;
    }
    var add = t.closest('[data-trg-add]');
    var swap = t.closest('[data-trg-swap]');
    var lente = t.closest('[data-trg-lente]');
    if (!add && !swap && !lente) return;
    e.preventDefault();
    if (busy) return;
    var inModal = !!(guard.el && guard.el.contains(t));
    setBusy(true);
    var job;
    if (add) {
      job = addGift(add.getAttribute('data-trg-k'), add.getAttribute('data-trg-add'));
    } else if (swap) {
      var upd = {}, oldq = Number(swap.getAttribute('data-trg-oldq')) || 1;
      upd[swap.getAttribute('data-trg-old')] = Math.max(0, oldq - 1);
      job = post('cart/update.js', { updates: upd }).then(function () { return addGift(swap.getAttribute('data-trg-k'), swap.getAttribute('data-trg-swap')); });
    } else {
      job = post('cart/add.js', { items: [{ id: Number(lente.getAttribute('data-trg-lente')), quantity: 1 }] });
    }
    job.then(rerender).catch(function () {}).then(function () {
      setBusy(false);
      if (inModal) afterPick();
      schedule();
    });
  });

  function relevant(n) {
    var el = n && (n.nodeType === 1 ? n : n.parentElement);
    if (!el || !el.closest) return false;
    if (el.closest('[data-touche-regalos], [data-trg-top], [data-trg-ficha], .trg-mpgift, .trg-modal')) return false;
    return !!el.closest('cart-drawer, #cart-drawer, cart-items, #main-cart-items, #main-cart-footer, [data-touche-mp], [data-cart-count-number], .cart-count-bubble');
  }
  function init() {
    run();
    if ('MutationObserver' in window) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var m = list[i];
          if (m.type === 'attributes') {
            if (m.target.hasAttribute('data-touche-mp') && m.target.getAttribute(m.attributeName) !== m.oldValue) { schedule(); return; }
          } else if (relevant(m.target)) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['data-tier', 'data-metodo'] });
    }
    try {
      if (window.FoxThemeEvents && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (!ev || ev.source !== 'touche-regalos') setTimeout(schedule, 60); });
      }
    } catch (e) {}
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
